import * as yup from "yup";

const trainingAttendedSchema = yup.object({
    organisationName: yup.string().required("Organisation name is required.")
});

export default trainingAttendedSchema;
